<template>
  <div>
    <blockquote v-if="activity.note">{{activity.note}}</blockquote>
    <blockquote class="text-muted" v-if="!activity.note">No notes</blockquote>
    <audio v-if="activity.recordingUrl" controls :src="activity.recordingUrl"></audio>
  </div>
</template>
<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true,
    }
  }
}
</script>
